import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/dialpad-wfm.vue
var o = {
	name: "DtIconDialpadWfm",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--dialpad-wfm"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Dialpad Wfm",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 .501a1.5 1.5 0 0 0-.749.2l-3.5 2H1.75A1.5 1.5 0 0 0 1 4v4a1.5 1.5 0 0 0 .75 1.298l.002.001 3.498 1.999a1.5 1.5 0 0 0 1.5 0l3.498-1.999.002-.001A1.5 1.5 0 0 0 11 8V4a1.5 1.5 0 0 0-.75-1.298l-3.5-2h-.001A1.5 1.5 0 0 0 6 .5Zm-.25 1.067a.5.5 0 0 1 .5 0L9.49 3.42 6 5.423 2.51 3.42l3.238-1.85.002-.002ZM2 8a.5.5 0 0 0 .25.431L5.5 10.29v-4L2 4.28V8Zm7.933.25a.503.503 0 0 1-.183.182L6.5 10.289v-4L10 4.28V8a.5.5 0 0 1-.067.25Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=dialpad-wfm.js.map